export enum EmailCollectionType {
	REJECTED = "REJECTED",
	CONTACT = "CONTACT",
}
